import { BfPageStoreProvider, useStoreState } from '@tw/tw-runtime-react';
import React, { useState, useEffect, useRef } from 'react';
/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import {
  TwBadgeRibbon,
  TwColumn,
  TwIconButton,
  TwImage,
  TwPage,
  TwRow,
  TwSectionHeader,
  TwStackedCard
} from '@tw/tw-components-rn';

import { CommonStore } from '@/app/core/store/common/common-store';
import { GiftGiftHomePageStore } from '../../stores/gift-home-page/gift-gift-home-page-store';
import { GoodItem } from '@/gift/component/good-item/GoodItem';
import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { ScrollView, View, Animated, Text } from 'react-native';
import birthdayImage from './assets/生日.png';
import birthdayImage2 from './assets/生日2.jpeg';
import yyfwsscImage from './assets/yyfwssc.jpg';
import hodoSupplyChainIcon from './assets/lingshou.jpg';
import { getGoodTypeColor } from '@/app/utils/utils';
import kaquan from './assets/卡券.png';
import libao from './assets/礼包.jpg';
import { styles } from './styles';
import { usePageStoreLifecycle } from '@tw/tw-runtime-react';

export const GiftGiftHomePage = (props) => {
  const [store] = useState(() => new GiftGiftHomePageStore());

  const commonStore = CommonStore.getInstance();
  const curActivity = useStoreState(commonStore, (state) => state.curActivity);

  usePageStoreLifecycle(store, undefined);
  const recommendGoods = useStoreState(store, (state) => state.recommendGoods);

  // 文字扫光动画
  const textSweepAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    // 创建文字扫光动画：从左到右循环
    const textSweepAnimation = Animated.loop(
      Animated.timing(textSweepAnim, {
        toValue: 1,
        duration: 2000,
        useNativeDriver: false
      })
    );
    
    textSweepAnimation.start();
    
    return () => {
      textSweepAnimation.stop();
    };
  }, [textSweepAnim]);

  // 炫彩文字颜色 - 模拟从左到右的彩虹扫过效果
  const titleText = '点击进入网上商城 ⬇️';
  const getCharColor = (index: number, totalChars: number) => {
    const position = index / totalChars;
    // 确保 inputRange 是单调递增的
    const start = Math.max(0, position - 0.1);
    const end = Math.min(1, position + 0.1);
    
    return textSweepAnim.interpolate({
      inputRange: [0, start, position, end, 1],
      outputRange: [
        '#FF0000', // 红色
        '#FF0000', // 红色
        '#FFD700', // 金色（高亮）
        '#00FF00', // 绿色
        '#00FF00'  // 绿色
      ],
      extrapolate: 'clamp'
    });
  };

  return (
    <BfPageStoreProvider store={store}>
      <TwPage translucentStatusBar={true} style={styles.container}>
        <ScrollView>
          <TwImage source={{ uri: curActivity?.pic?.url }} style={styles.headerImage}></TwImage>
          {/* 快速导航区 */}
          <TwRow style={styles.courseContainer}>
            <TwIconButton
              style={styles.iconButton}
              icon={<TwImage source={hodoSupplyChainIcon} size={12} />}
              label={'零售专区'}
              direction={'vertical'}
              size={48}
              onPress={() => {
                props.navigation.navigate(ROUTE_NAMES.HomeIndex, {
                  screen: ROUTE_NAMES.GiftGiftMall,
                  params: { productType: 'open_package' }
                });
              }}
            />
            <TwIconButton
              style={styles.iconButton}
              icon={<TwImage source={libao} size={12} />}
              label={'礼包专区'}
              direction={'vertical'}
              size={48}
              onPress={() => {
                props.navigation.navigate(ROUTE_NAMES.HomeIndex, {
                  screen: ROUTE_NAMES.GiftGiftMall,
                  params: { productType: 'fixed_package' }
                });
              }}
            />
            <TwIconButton
              style={styles.iconButton}
              icon={<TwImage source={kaquan} size={12} />}
              label={'卡券专区'}
              direction={'vertical'}
              size={48}
              onPress={() => {
                props.navigation.navigate(ROUTE_NAMES.HomeIndex, {
                  screen: ROUTE_NAMES.GiftGiftMall,
                  params: { productType: 'sale_card' }
                });
              }}
            />
          </TwRow>

          {/* 节日商品选择区 */}
          <TwColumn space={2} style={styles.goodContainer}>
            <TwSectionHeader title={'热销推荐'}></TwSectionHeader>
            <ScrollView style={{ flex: 1 }} horizontal={true}>
              <TwRow space={2}>
                {recommendGoods?.map((item, index) => {
                  return (
                    <TwBadgeRibbon
                      key={index}
                      title={item.type.name}
                      titleBackgroundColor={getGoodTypeColor(item.type.code)}
                      titleColor="#fff"
                    >
                      <GoodItem
                        {...item}
                        style={styles.cardContainer}
                        imageStyle={styles.image}
                        subStyle={styles.subtitle}
                        onPress={() => store.onGoodClick(item)}
                      />
                    </TwBadgeRibbon>
                  );
                })}
              </TwRow>
            </ScrollView>
          </TwColumn>
          <TwColumn space={1} style={styles.borthContainer}>
            <View style={{ paddingVertical: 8 }}>
              <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                {titleText.split('').map((char, index) => (
                  <Animated.Text
                    key={index}
                    style={{
                      color: getCharColor(index, titleText.length),
                      fontWeight: 'bold',
                      fontSize: 16
                    }}
                  >
                    {char}
                  </Animated.Text>
                ))}
              </View>
            </View>
            <TwStackedCard
              style={styles.borthCardContainer}
              imageStyle={styles.borthImage}
              title={'烨旖梵网上商城'}
              imageUrl={yyfwsscImage}
              header=""
              mode="quiet"
              subtitle={'这是零售商品自选专区'}
              onPress={() => {
                store.onYyfPress();
              }}
            />
          </TwColumn>
          {/* 生日卡券区 2024-01-04 */}
          <TwColumn space={1} style={styles.borthContainer}>
            <TwSectionHeader title={'生日'}></TwSectionHeader>
            <TwStackedCard
              style={styles.borthCardContainer}
              imageStyle={styles.borthImage}
              title={new Date().getFullYear() + '年生日礼包'}
              imageUrl={birthdayImage2}
              header=""
              mode="quiet"
              subtitle={'这是一个生日礼包'}
              onPress={() => {
                store.onBirthday2Press();
              }}
            />
          </TwColumn>

          {/* 生日卡券区 */}
          <TwColumn space={1} style={styles.borthContainer}>
            <TwSectionHeader title={'生日'}></TwSectionHeader>
            <TwStackedCard
              style={styles.borthCardContainer}
              imageStyle={styles.borthImage}
              title={'2023年生日礼包'}
              imageUrl={birthdayImage}
              header=""
              mode="quiet"
              subtitle={'这是一个生日礼包'}
              onPress={() => {
                store.onBirthdayPress();
              }}
            />
          </TwColumn>
        </ScrollView>
      </TwPage>
    </BfPageStoreProvider>
  );
};
